import { Field } from '../../../models/field.model'
import { MovementField } from './movement-search.model'
import { MovementViewType } from './movement.types'

export const MOVEMENT_FIELDS: Field<MovementField, MovementViewType>[] = [
  {
    label: 'Created at',
    field: 'createdAt',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'SKU',
    field: 'SKU',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Product name',
    field: 'name',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Quantity',
    field: 'qty',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Stock',
    field: 'onHandQty',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Sign',
    field: 'sign',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Reason',
    field: 'reason',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Code',
    field: 'details.code',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Name',
    field: 'details.name',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Warehouse',
    field: 'warehouseId',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Path',
    field: 'location.path',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Location code',
    field: 'location.code',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Picking list name',
    field: 'pickingListName',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Goods receive ref.',
    field: 'goodsReceiveRef',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Order num.',
    field: 'order.orderNumber',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Order rif.',
    field: 'order.rifOrder',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'User',
    field: 'userId',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
  {
    label: 'Lot',
    field: 'lot',
  },
  {
    label: 'Expiration date',
    field: 'expirationDate',
  },
  {
    label: 'Serial',
    field: 'serial',
  },
  {
    label: 'Notes',
    field: 'notes',
    defaultViews: ['MOVEMENTS_LISTING_MAIN'],
  },
]
